import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-036a1cea"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-col" };
const _hoisted_2 = { class: "flex justify-center pt-16 pb-3 bg-orange-600" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("defs", null, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M84.959 37.494H74.06c-.619 0-1.12.503-1.12 1.123 0 3.638 2.94 6.587 6.569 6.587 3.628 0 6.569-2.949 6.569-6.587 0-.62-.502-1.123-1.12-1.123z",
        id: "a"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M9.304 39.17H-1.594c-.619 0-1.12.504-1.12 1.124 0 3.638 2.941 6.587 6.57 6.587 3.627 0 6.568-2.95 6.568-6.587 0-.62-.501-1.123-1.12-1.123z",
        id: "b"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M80.844 56.89l-10.898-.001a1.12 1.12 0 00-1.12 1.123c0 3.637 2.942 6.587 6.57 6.587s6.569-2.948 6.568-6.586c0-.62-.501-1.123-1.12-1.123z",
        id: "c"
    })
], -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#DDDBEA",
        "stroke-width": "1.681",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M5.044 140.162h186.615"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "translate(89.104 17.766)" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            "fill-opacity": ".1",
            fill: "#67D1E1",
            width: "25.218",
            height: "121.557",
            rx: "4.203"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M85.589 16.008l-12.135 2.14a8.857 8.857 0 00-7.184 10.26l1.544 8.758a4.466 4.466 0 01-8.796 1.551l-1.544-8.758a8.857 8.857 0 00-10.26-7.184l-12.135 2.14a5.905 5.905 0 00-4.834 6.547l9.567 76.555a5.905 5.905 0 006.884 5.082l58.137-10.25a5.905 5.905 0 004.73-7.132L92.37 20.507a5.905 5.905 0 00-6.781-4.499z",
            stroke: "#67D1E1",
            "stroke-width": ".51",
            fill: "#67D1E1"
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            transform: "scale(-1 1) rotate(10 -320.387 -401.172)",
            fill: "#00292B"
        }, [
            /*#__PURE__*/ _createElementVNode("ellipse", {
                cx: "2.233",
                cy: "1.111",
                rx: "1.116",
                ry: "1.111"
            }),
            /*#__PURE__*/ _createElementVNode("ellipse", {
                cx: "15.63",
                cy: "1.111",
                rx: "1.116",
                ry: "1.111"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                d: "M12.839 11.663c0-2.944-1.51-4.443-3.907-4.443-2.398 0-3.908 1.499-3.908 4.443 1.006-.888 2.309-1.333 3.907-1.333 1.6 0 2.902.445 3.908 1.333z",
                stroke: "#00292B",
                "stroke-width": "1.107",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("g", {
            "fill-rule": "nonzero",
            transform: "rotate(80 39.156 25.206)"
        }, [
            /*#__PURE__*/ _createElementVNode("use", {
                fill: "#67D1E1",
                "xlink:href": "#a"
            }),
            /*#__PURE__*/ _createElementVNode("use", {
                "fill-opacity": ".2",
                fill: "#FFF",
                "xlink:href": "#a"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("g", {
            "fill-rule": "nonzero",
            transform: "scale(1 -1) rotate(-80 -4.706 -66.926)"
        }, [
            /*#__PURE__*/ _createElementVNode("use", {
                fill: "#67D1E1",
                "xlink:href": "#b"
            }),
            /*#__PURE__*/ _createElementVNode("use", {
                "fill-opacity": ".2",
                fill: "#FFF",
                "xlink:href": "#b"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("rect", {
            "fill-opacity": ".1",
            fill: "#67D1E1",
            width: "115.163",
            height: "121.557",
            rx: "4.203"
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            stroke: "#FFF",
            "stroke-linecap": "round"
        }, [
            /*#__PURE__*/ _createElementVNode("path", {
                d: "M102.974 6.287h3.324a3.362 3.362 0 013.362 3.363v32.685h0",
                "stroke-width": "1.681",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                "stroke-width": ".841",
                d: "M9.281 14.251L32.394 9.56v4.305m5.232-6.205l-5.232 1.9 7.526 5.66m-14.596 7.414l-11.866-9.287m7.38 14.591l1.438-7.4"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M26.977 111.578a.84.84 0 01-1.656.291.84.84 0 011.656-.291zm15.82-5.66a.837.837 0 01-.104 1.18.842.842 0 01-1.185-.103.837.837 0 01.104-1.181.842.842 0 011.184.103zm-15.91-.268a.84.84 0 01-1.656.291.84.84 0 011.656-.291zm9.702-.94a.84.84 0 01-1.656.291.84.84 0 011.656-.291zm-7.48-5.773a.84.84 0 01-1.656.291.84.84 0 011.656-.291zm25.317-1.756a.837.837 0 01-.104 1.181.842.842 0 01-1.184-.103.837.837 0 01.103-1.181.842.842 0 011.185.103zm-23.727-3.434a.84.84 0 01-1.656.291.84.84 0 011.656-.291zm17.4-9.17a.837.837 0 01-.103 1.18.842.842 0 01-1.185-.103.837.837 0 01.104-1.181.842.842 0 011.184.103zm-20.762-.052a.84.84 0 01-1.656.291.84.84 0 011.656-.291zm82.716-32.482l.105.011a.839.839 0 11-.292 1.652.839.839 0 11.292-1.652zM93.365 40.367a.842.842 0 011.184-.103.837.837 0 01.104 1.181.842.842 0 01-1.184.103.837.837 0 01-.104-1.18zm16.778-.958l.105.012a.839.839 0 11-.292 1.65.839.839 0 11.292-1.65zm-9.701-.94l.105.012a.839.839 0 11-.292 1.65.839.839 0 11.292-1.65zm-5.655-6.03a.842.842 0 011.184-.103.837.837 0 01.104 1.181.842.842 0 01-1.184.104.837.837 0 01-.104-1.181zm-13.051-.808a.842.842 0 011.184-.103.837.837 0 01.104 1.181.842.842 0 01-1.185.103.837.837 0 01-.103-1.18zm24.595-4.126l.105.012a.839.839 0 11-.292 1.651.839.839 0 11.292-1.651zm3.362-9.221l.105.011a.839.839 0 11-.292 1.652.839.839 0 11.292-1.652zM94.473 5.869l.104.012a.839.839 0 11-.292 1.651.839.839 0 11.292-1.65zm-3.29 77.092a.84.84 0 011.288-1.08.84.84 0 01-1.288 1.08zm-10.87 12.812a.837.837 0 01-.5-1.075.842.842 0 011.077-.502c.436.158.66.639.5 1.074a.842.842 0 01-1.076.503zm13.912-7.724a.84.84 0 011.288-1.08.84.84 0 01-1.288 1.08zm-7.932 5.665a.84.84 0 011.288-1.08.84.84 0 01-1.288 1.08zm9.365 1.26a.84.84 0 011.288-1.08.84.84 0 01-1.288 1.08zM72.02 105.857a.837.837 0 01-.501-1.075.842.842 0 011.077-.502c.436.158.66.639.5 1.074a.842.842 0 01-1.076.503zm24.854-5.593a.84.84 0 011.288-1.08.84.84 0 01-1.288 1.08zm6.488-20.536a.837.837 0 01-.501-1.074.842.842 0 011.077-.503c.436.158.66.64.501 1.075a.842.842 0 01-1.077.502zm1.035 26.841a.84.84 0 011.288-1.08.84.84 0 01-1.288 1.08z",
            fill: "#FFF"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M20.677 7.707h14.558c7.003 0 12.68 5.676 12.68 12.68v9.527a3.152 3.152 0 003.152 3.152 4.032 4.032 0 003.913-3.06l.29-1.167a5.57 5.57 0 015.406-4.226h1.95a6.626 6.626 0 016.617 6.297l3.188 64.116c.369 7.419-5.346 13.732-12.765 14.101a13.45 13.45 0 01-.668.017H21.444c-7.428 0-13.45-6.022-13.45-13.45 0-.651.048-1.302.142-1.946l8.256-56.456c-5.803 0-10.508-4.704-10.508-10.507V22.5c0-8.17 6.623-14.793 14.793-14.793z",
        fill: "#FFAF20"
    }),
    /*#__PURE__*/ _createElementVNode("g", {
        transform: "translate(39.509 43.632)",
        fill: "#00292B"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M12.482 7.924a.785.785 0 011.113-.06c.324.292.35.793.06 1.118a7.063 7.063 0 01-10.564.002.796.796 0 01.06-1.12.785.785 0 011.114.062 5.487 5.487 0 008.217-.002z",
            "fill-rule": "nonzero"
        }),
        /*#__PURE__*/ _createElementVNode("ellipse", {
            cx: "2.102",
            cy: "1.057",
            rx: "1.051",
            ry: "1.057"
        }),
        /*#__PURE__*/ _createElementVNode("ellipse", {
            cx: "14.711",
            cy: "1.057",
            rx: "1.051",
            ry: "1.057"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("g", {
        "fill-rule": "nonzero",
        transform: "scale(1 -1) rotate(-87 10.857 -.5)"
    }, [
        /*#__PURE__*/ _createElementVNode("use", {
            fill: "#FFAF20",
            "xlink:href": "#c"
        }),
        /*#__PURE__*/ _createElementVNode("use", {
            "fill-opacity": ".2",
            fill: "#FFF",
            "xlink:href": "#c"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M21.856 116.689l-5.044 22.634H12.61l5.044-22.634h4.203zm42.03 0l5.044 22.634h-4.203l-5.044-22.634h4.203zm-17.653 0v22.634H42.03V116.69h4.203zm26.06-6.707v5.868H6.724v-5.868h65.567zm-54.22 18.024H40.77m6.305 0h16.812",
        stroke: "#DDDBEA",
        "stroke-width": "1.681",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#ACAAC3",
        "stroke-width": "5.044",
        "stroke-linecap": "round",
        d: "M78.051 64.72l1.96-37.394"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#F7F7FF",
        "stroke-width": "1.681",
        fill: "#F7F7FF",
        "stroke-linejoin": "round",
        d: "M75.725 25.427l20.987 1.1 7.292 5.419-28.542-1.496z"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "translate(0 1)" }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M49.596 21.796C49.596 9.902 44.61.233 31.826.004 31.672.001 20.909 0 20.755 0c-13 0-18.233 9.759-18.233 21.796h47.074z",
            fill: "#F7F7FF"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M17.898.332C10.262 3.778 7.038 12.16 7.038 21.95M33.93.332C41.566 3.778 44.79 12.16 44.79 21.95",
            stroke: "#DDDBEA",
            "stroke-width": ".841",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }),
        /*#__PURE__*/ _createElementVNode("rect", {
            fill: "#DDDBEA",
            y: "20.958",
            width: "52.118",
            height: "4.192",
            rx: "1.681"
        })
    ])
], -1));
const _hoisted_6 = [
    _hoisted_4,
    _hoisted_5
];
const _hoisted_7 = { class: "flex flex-col items-center px-8" };
const _hoisted_8 = { class: "mt-2 text-4xl font-bold text-center" };
const _hoisted_9 = { class: "flex flex-col mt-2 space-y-4 max-w-101" };
const _hoisted_10 = { class: "flex items-center justify-between pb-6 pl-4 pr-8 mt-12 space-x-4" };
const _hoisted_11 = { class: "flex items-center space-x-2" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.lobby.ice_breakers.free_modal'),
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import transitions from '@/helpers/transitions';
import Dialog from '@/components/Dialog.vue';
import Modal from '@/components/Modal.vue';
import NonFreeLabel from '@/components/pricing/NonFreeLabel.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'FreeIceBreakerModal',
    props: {
        isOpen: { type: Boolean }
    },
    emits: ["update:isOpen"],
    setup(__props, { emit }) {
        const { scale } = transitions;
        const { scaleIn, scaleOut } = scale;
        function handleClose() {
            emit('update:isOpen', false);
        }
        return (_ctx, _cache) => {
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_TransitionA11y = _resolveComponent("TransitionA11y");
            return (_openBlock(), _createBlock(Modal, { class: "p-4" }, {
                default: _withCtx(() => [
                    _createVNode(_component_TransitionA11y, {
                        css: false,
                        enter: _unref(scaleIn),
                        leave: _unref(scaleOut)
                    }, {
                        default: _withCtx(() => [
                            (__props.isOpen)
                                ? (_openBlock(), _createBlock(Dialog, {
                                    key: 0,
                                    class: "dialog"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, [
                                            _createElementVNode("div", _hoisted_2, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    width: "206",
                                                    height: "141",
                                                    viewBox: "0 0 206 141",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                                    "svg-inline": '',
                                                    class: _normalizeClass('h-34'),
                                                    src: '@/assets/images/iceBreakers/icebreakers-dudes.svg',
                                                    alt: ''
                                                }, _hoisted_6, 8, _hoisted_3))
                                            ]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('title')), 1),
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('paragraph_1')), 1),
                                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('paragraph_2')), 1),
                                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('paragraph_3')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createVNode(NonFreeLabel),
                                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('upgrade_suggestion')), 1)
                                                ]),
                                                _createVNode(_component_PillButton, { onClick: handleClose }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('accept')), 1)
                                                    ], undefined, true),
                                                    _: 1
                                                })
                                            ])
                                        ])
                                    ], undefined, true),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                    }, 8, ["enter", "leave"])
                ], undefined, true),
                _: 1
            }));
        };
    }
});
